import { Button } from "@material-ui/core";
import * as React from "react";
import { t } from "../../i18n/util";
import { THEME } from "../../theme/ThemeStore";

export const GoogleButton = ({
    type,
    onClick,
    style
}: {
    type?: "submit";
    onClick?: () => void;
    style?: React.CSSProperties;
}) => (
    <Button
        variant="contained"
        style={{
            color: THEME.customColors.body2Dark,
            backgroundColor: "#FFFFFF",
            flexShrink: 0,
            padding: 8,
            borderRadius: 4,
            textTransform: "uppercase",
            ...style
        }}
        type={type}
        onClick={onClick}
        disableRipple
    >
        <img src={THEME.Images.icGoogle} alt="" style={{ width: 18, height: 18 }} />
        <div
            style={{
                fontWeight: 600,
                fontSize: 14,
                marginLeft: 24
            }}
        >
            {t("screen.login.signInWithGoogle")}
        </div>
    </Button>
);
